import ApplicationController from './application'

export default class extends ApplicationController {

  connect() {
    window.scrollTo(0, 0)
  }
}
